// src/util/socket.js
import { io } from 'socket.io-client';
import { getStore } from '../storeInstance';
import { fetchCurrentUser } from '../ducks/user.duck';
import { refreshConversations } from '../containers/InboxPage/InboxPage.duck';
import { apiBaseUrl } from './api';

// An explicit socket URL always wins. In development the socket must reach the same local API
// server that sends the messages, whatever the marketplace root URL points at, so it is chosen
// exactly as the API base URL is. Elsewhere the marketplace root URL is used as before.
const resolveSocketUrl = () => {
  if (process.env.REACT_APP_SOCKET_IO_URL) return process.env.REACT_APP_SOCKET_IO_URL;
  const rootUrl = process.env.REACT_APP_MARKETPLACE_ROOT_URL;
  const useDevApiServer =
    process.env.NODE_ENV === 'development' && !!process.env.REACT_APP_DEV_API_SERVER_PORT;
  if (useDevApiServer) return apiBaseUrl(rootUrl);
  return rootUrl !== 'http://localhost:3000' ? rootUrl : 'http://localhost:4000';
};

const ioUrl = resolveSocketUrl();

const socket = io(ioUrl, {
  transports: ['websocket', 'polling'],
  withCredentials: true,
});

// On every (re)connect, rejoin all conversation rooms from Redux state.
// Rooms are server-side session state — lost on disconnect. Without this,
// after a sleep/network drop the client reconnects but misses all broadcasts.
socket.on('connect', () => {
  try {
    const appStore = getStore && getStore();
    if (!appStore) return;
    const conversations = appStore.getState()?.InboxPage?.conversations || [];
    conversations.forEach(conv => {
      if (conv.conversationId) socket.emit('join-conversation', conv.conversationId);
    });
  } catch (e) {
    console.error('Error rejoining conversation rooms on reconnect', e);
  }
});

// New message — refresh conversations (unread counts) + Sharetribe notification count
socket.on('message:new', () => {
  try {
    const appStore = getStore && getStore();
    if (appStore && typeof appStore.dispatch === 'function') {
      appStore.dispatch(refreshConversations()).catch(() => {});
      appStore.dispatch(fetchCurrentUser({ updateNotifications: true })).catch(() => {});
    }
  } catch (e) {
    console.error('Error handling message:new socket event', e);
  }
});

export default socket;
